/* Precarga de enlaces compatible con quicklink (API listen/prefetch).
   Nunca precarga carrito, checkout ni cuenta, con cualquier prefijo de mercado
   (/en-us/, /en-row/, /en-intl/, /es-lat/...), ni enlaces que cambien cantidades:
   precargar /cart/change?...&quantity=0 vaciaba el carrito. */
(function (w, d) {
  var BLOCK_PATH = /(^|\/)(account|cart|checkouts?|login|logout|localization|challenge)(\/|$)/i;
  var BLOCK_QUERY = /[?&](quantity|line)=/i;
  var seen = {};

  function unsafe(href) {
    try {
      var u = new URL(href, location.href);
      return u.origin !== location.origin || BLOCK_PATH.test(u.pathname) || BLOCK_QUERY.test(u.search);
    } catch (e) {
      return true;
    }
  }

  function slowNetwork() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /2g/.test(c.effectiveType || '')));
  }

  function prefetch(href) {
    if (seen[href] || unsafe(href) || slowNetwork()) return;
    seen[href] = true;
    var link = d.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    d.head.appendChild(link);
  }

  function ignored(ignores, href, el) {
    for (var i = 0; i < ignores.length; i++) {
      var rule = ignores[i];
      if (typeof rule === 'function' ? rule(href, el) : rule && rule.test && rule.test(href)) return true;
    }
    return false;
  }

  function listen(opts) {
    opts = opts || {};
    var ignores = [].concat(opts.ignores || []);
    if (!('IntersectionObserver' in w)) return function () {};
    var idle = w.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var href = entry.target.href;
        if (!href || unsafe(href) || ignored(ignores, href, entry.target)) return;
        idle(function () { prefetch(href); });
      });
    });
    var root = opts.el || d;
    var links = root.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) io.observe(links[i]);
    return function () { io.disconnect(); };
  }

  w.quicklink = {
    listen: listen,
    prefetch: function (urls) {
      [].concat(urls || []).forEach(prefetch);
      return Promise.resolve();
    }
  };
})(window, document);
